import React from 'react'

const Footer = () => {
    return (
        <footer>
            <div>
                <h1>TechStark</h1>
                <p>@all rights are reserved</p>
            </div>
            <div>
                <h5>Follow us</h5>
                <div>
                    <a href="https://youtube.com/" target={"blank"}>Youtube</a>
                    <a href="https://instagram.com/" target={"blank"}>Instagram</a>
                    <a href="https://github.com/Jagss24" target={"blank"}>Github</a>
                </div>
            </div>
        </footer>
    )
}

export default Footer